import firebase from "firebase";
import "firebase/firestore";

import store from "./store";

var firebaseConfig = {
  apiKey: "AIzaSyCaIu87d1Su-OmBlmjI0CLaNQrewyX89XA",
  authDomain: "covid19pad-672e5.firebaseapp.com",
  databaseURL: "https://covid19pad-672e5.firebaseio.com",
  projectId: "covid19pad-672e5",
  storageBucket: "covid19pad-672e5.appspot.com",
  messagingSenderId: "610387441915",
  appId: "1:610387441915:web:2dcbee11d01b725288185e",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const storage = firebaseApp.storage();
const fieldValue = firebase.firestore.FieldValue;
const auth = firebase.auth();
const functions = firebase.functions();
const currentUser = auth.currentUser;

// date issue fix according to firebase
if (location.hostname === "localhost" && false) {
  //   db.settings({
  //     host: "localhost:8070",
  //     ssl: false,
  //   });
  //   firebase.functions().useFunctionsEmulator("http://localhost:5000");
} else {
}
const settings = {};
db.settings(settings);

//When ever the user authentication state changes write the user to vuex.

export default {
  db,
  auth,
  functions,
  currentUser,
  fieldValue,
  storage,
};

export { db, auth, functions, currentUser, fieldValue, storage };
